export const orgFormData = [{
    key: 'seller_name',
    type: 'select',
    value: '',
    valid: false,
    regex: "^\\d+$",
    elementConfig: {
        name: 'seller_name',
        label: 'Seller Name',
        options: [],
        storeKey: ['seller', 'seller', 'data', 'seller_list']
    },
    validation: {
        required: true,
        message: "should be choosen"
    },

}, {
    key: 'organisation_name',
    type: 'text',
    value: '',
    valid: false,
    fieldValid:true,
    regex: ".+",
    elementConfig: {
        name: 'organisation_name',
        label: 'Name',
        placeholder: 'Organisation Name PVT LTD'
    },
    validation: {
        required: true,
        message: "is required"
    },
    fieldValidation:{
        required: "^(?:[a-zA-Z0-9 ]*)?$",
        message: "is invalid"
    }
}, {
    key: 'organisation_code',
    type: 'text',
    value: '',
    valid: false,
    regex: ".+",
    elementConfig: {
        name: 'organisation_code',
        label: 'Code',
        placeholder: 'ORG'
    },
    validation: {
        required: true,
        message: "is required"
    },
}, {
    key: 'address',
    type: 'text',
    value: '',
    valid: false,
    regex: ".+",
    elementConfig: {
        name: 'address',
        label: 'Address',
        placeholder: ''
    },
    validation: {
        required: true,
        message: "is required"
    },
}, {
    key: 'city',
    type: 'text',
    value: '',
    valid: true,
    fieldValid:true,
    // regex: "^[a-zA-Z]+$",
    elementConfig: {
        name: 'city',
        label: 'City',
        placeholder: ''
    },
    validation: {
        required: false,
        message: ""
    },
    fieldValidation:{
        required:"^(?:[a-zA-Z]+(?:[ ]+[a-zA-Z]+)*)?$",
        message: "is invalid"
    }
}, {
    key: 'pincode',
    type: 'text',
    value: '',
    valid: true,
    fieldValid:true,
    elementConfig: {
        name: 'pincode',
        label: 'Pincode',
        placeholder: ''
    },
    validation: {
        required: false,
        message: "should be 6 digits"
    },
    fieldValidation:{
        required: "^(?:[1-9][0-9]{5})?$",
        message: "is invalid"
    }
}, {
    key: 'state',
    type: 'text',
    value: '',
    valid: true,
    fieldValid:true,
    // regex: "^[a-zA-Z]+$",
    elementConfig: {
        name: 'state',
        label: 'State',
        placeholder: ''
    },
    validation: {
        required: false,
        message: ""
    },
    fieldValidation:{
        required:"^(?:[a-zA-Z]+(?:[ ]+[a-zA-Z]+)*)?$",
        message: "is invalid"
    }
}, {
    key: 'country_name',
    type: 'select',
    value: '',
    valid: true,
    regex: "^\\d+$",
    elementConfig: {
        name: 'country_name',
        label: 'Country',
        options: [],
        storeKey: ['countries', 'countries']
    },
    validation: {
        required: false,
        message: "Country is required"
    },
}, {
    key: 'relation_list',
    type: 'hidden',
    value: '',
    valid: true,
    elementConfig: {
        name: 'relation_list',
        label: '',
    },
    validation: {
        required: false,
        message: ''
    }
},
]


// WEBPACK FOOTER //
// ./src/_pages/Admin/Organisation/component/orgFormData.js